// Pagina pubblica /privacy — landing diritti GDPR cittadino (Sprint 7).

import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { AudiqWordmark, RuleBicolor } from '@audiq/ui';
import { LangSwitcher } from '../components/LangSwitcher';

export function PrivacyLandingPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-dvh" style={{ background: 'var(--surface)', color: 'var(--ink)' }}>
      <header className="flex items-center justify-between p-4">
        <Link to="/">
          <AudiqWordmark size="sm" />
        </Link>
        <LangSwitcher />
      </header>

      <main className="mx-auto max-w-3xl p-6">
        <div className="mono mb-2" style={{ color: 'var(--mute)' }}>
          {t('privacy.kicker', 'I tuoi dati · GDPR')}
        </div>
        <h1 className="serif text-4xl">{t('privacy.title', 'I tuoi diritti sui dati')}</h1>
        <RuleBicolor className="my-5 max-w-[12rem]" />
        <p className="text-base leading-relaxed" style={{ color: 'var(--ink)' }}>
          {t(
            'privacy.intro',
            'Audiq raccoglie informazioni durante la conversazione con te. Hai il diritto di accedervi o di chiederne la cancellazione in qualunque momento.',
          )}
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          <Link
            to="/privacy/access"
            className="audiq-dog-ear block rounded-md border p-5 hover:opacity-90"
            style={{ background: 'var(--paper)', borderColor: 'var(--line)' }}
          >
            <h2 className="serif text-2xl mb-2" style={{ color: 'var(--ink)' }}>
              {t('privacy.access.title', 'Accedi ai tuoi dati')}
            </h2>
            <p className="text-sm" style={{ color: 'var(--mute)' }}>
              {t(
                'privacy.access.desc',
                'Scarica un file con tutti i dati che Audiq ha raccolto su di te.',
              )}
            </p>
          </Link>

          <Link
            to="/privacy/delete"
            className="audiq-dog-ear block rounded-md border p-5 hover:opacity-90"
            style={{ background: 'var(--paper)', borderColor: 'var(--line)' }}
          >
            <h2 className="serif text-2xl mb-2" style={{ color: 'var(--ink)' }}>
              {t('privacy.delete.title', 'Cancella i tuoi dati')}
            </h2>
            <p className="text-sm" style={{ color: 'var(--mute)' }}>
              {t(
                'privacy.delete.desc',
                'Elimina definitivamente tutti i dati che Audiq detiene su di te. Non è reversibile.',
              )}
            </p>
          </Link>
        </div>

        <div className="mt-10 text-sm" style={{ color: 'var(--mute)' }}>
          <Link to="/informativa" className="underline">
            {t('privacy.fullInfo', 'Informativa completa privacy')}
          </Link>
        </div>
      </main>
    </div>
  );
}
